/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'ai-mate.chat-error-banner.description': 'Tu historial de chat se guarda durante un máximo de 30 días.',
  'ai-mate.chat-error-banner.title': 'Iniciar nuevo chat',
  'ai-mate.chat-error.description': 'Prueba a <btn>volver a cargar el chat</btn>.',
  'ai-mate.chat-error.rate-limited-description':
    'Has alcanzado el número máximo de solicitudes. Inténtalo de nuevo más tarde.',
  'ai-mate.chat-error.rate-limited-title': 'Demasiadas solicitudes',
  'ai-mate.chat-error.rovo-inactive-description':
    'Parece que Rovo no está activado en tu sitio. <link>Configurar Rovo</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo está inactivo',
  'ai-mate.chat-error.title': 'No tenemos claro qué ha salido mal',
  'ai-mate.main-chat.close-chat-button-label': 'Cerrar',
  'ai-mate.main-chat.maximize-chat-button-label': 'Pantalla completa',
  'ai-mate.main-chat.minimize-chat-button-label': 'Restablecer vista',
  'ai-mate.main-chat.new-chat-button-label': 'Nuevo',
  'ai-mate.main-chat.new-chat-button-label-full-screen': 'Nuevo chat',
  'conversation-assistant-button.label': 'Chat',
  'conversation-assistant-button.rovo-chat-label': 'Chat de Rovo',
  'highlight-actions.rovo-chat-custom-prompt-submit-button.text': 'Enviar',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Pregúntale a la IA sobre esto',
  'highlight-actions.rovo-chat-explain-option.text': 'Explicar',
  'highlight-actions.rovo-chat-explain-prompt':
    'Explica esto reformulándolo y añadiendo más detalles, pero utiliza un lenguaje muy sencillo y frases cortas, y define o pon ejemplos para todos los términos técnicos empleados en el texto original.',
  'highlight-actions.rovo-chat-find-resources-option.text': 'Encontrar recursos',
  'highlight-actions.rovo-chat-find-resources-prompt':
    'Encuentra recursos únicamente de la base de conocimiento de la organización que corroboren las afirmaciones realizadas.',
  'highlight-actions.rovo-chat-give-examples-option.text': 'Proporciona ejemplos',
  'highlight-actions.rovo-chat-give-examples-prompt':
    'Pon ejemplos de esto extraídos de los recursos de la organización o del conocimiento público. Si no hay ningún recurso que se pueda proporcionar, intenta poner un ejemplo metafórico que pueda ayudar a alguien a entenderlo mejor.',
  'highlight-actions.rovo-chat-give-feedback-option.text': 'Enviar comentarios',
  'highlight-actions.rovo-chat-give-feedback-prompt':
    'Revisa la redacción de este texto y dame tu opinión. Haz comentarios sobre la elección de palabras, la gramática y la puntuación. Hazlo de forma positiva y entusiasta, pero aporta siempre al menos una cosa que mejorar o cambiar.',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Recomendaciones de chat',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Abrir chat',
  'highlight-actions.rovo-chat-summarize-option.text': 'Resumir',
  'highlight-actions.rovo-chat-summarize-prompt':
    'Resalta los puntos clave de esto. Céntrate en la información esencial y excluye los detalles innecesarios. Ofrece una descripción concisa en un solo párrafo.',
  'highlight-actions.rovo-chat.button-text': 'Chat',
  'highlight-actions.rovo-chat.button-text-ask-in-chat': 'Preguntar en el chat',
  'horizontal-scroll-container.scroll-left': 'Desplazarse a la izquierda',
  'horizontal-scroll-container.scroll-right': 'Desplazarse a la derecha',
};
